<template>
  <div class="UserWithOrder">
    <el-tabs type="border-card" style="margin: 0 .2rem;" v-model="payerShowTab" @tab-click="handlePayerClick">
      <el-tab-pane label="用户信息" name="1">
        <el-row class="m-tab">
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="姓名" placement="top"> -->
            <span class="count-style">姓名</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.nickname" placement="top"> -->
            <span class="count-style">{{ PayerData.nickname }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="昵称" placement="top"> -->
            <span class="count-style">昵称</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <span>{{ maskedName(PayerData.name) }}</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="手机号" placement="top"> -->
            <span class="count-style">手机号</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.phone" placement="top"> -->
            <span class="count-style">
              <el-link style="color: #409EFF;cursor: pointer" :underline="false"
                @click="openPhoneFromDraw(PayerData.phone)">{{ showFullNumber ? phoneNumber : maskedNumber }}</el-link>
              <!-- <el-tooltip effect="drak" content="电话外呼" placement="right"> -->
              <i @click="makePhone(PayerData.phone)" class="el-icon-phone-outline"
                style="color: #409EFF;cursor:pointer;"></i>
              <!-- </el-tooltip> -->
              <i class="el-icon-view eye-icon" style="color: #409EFF;cursor: pointer;"
                @click.prevent="toggleShowFullNumber" :class="{ active: showFullNumber }"></i>
              <i class="el-icon-document-copy" style="color: #409EFF;margin-left:0.1rem;cursor:pointer"
                @click="copyPhone(PayerData.phone)"></i>
            </span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="所属业务" placement="top"> -->
            <span class="count-style">所属业务</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip placement="top"> -->
            <span class="count-style">{{ PayerData.business ? PayerData.business.username : '' }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="注册时间" placement="top"> -->
            <span class="count-style">注册时间</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.regtime" placement="top"> -->
            <span class="count-style">{{ PayerData.regtime }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="客户来源" placement="top"> -->
            <span class="count-style">客户来源</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.user_from" placement="top"> -->
            <span class="count-style">{{ PayerData.user_from }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="客户身份" placement="top"> -->
            <span class="count-style">客户身份</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.user_level" placement="top"> -->
            <span class="count-style">{{ PayerData.user_level }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="是否线索" placement="top"> -->
            <span class="count-style">是否线索</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td" v-if="ThreadData && ThreadData.admin === null">
            <el-link type="primary" :underline="false" style="padding: 0; border: none;color:#409EFF;"
              @click="handleShowChatRecordOpen(ThreadData.thread_id)">
              <el-tooltip content="未认领" placement="top">
                <span class="count-style" style="font-size: 16px;" content="是">是</span>
              </el-tooltip>
            </el-link>
          </el-col>
          <el-col :span="8" class="m-td" v-else-if="ThreadData && ThreadData.admin">
            <el-link type="primary" :underline="false" style="padding: 0; border: none;color:#409EFF;"
              @click="handleShowChatRecordOpen(ThreadData.thread_id)">
              <el-tooltip :content="ThreadData.admin.username" placement="top">
                <span class="count-style" style="font-size: 16px;" content="是">是</span>
              </el-tooltip>
            </el-link>
          </el-col>
          <el-col :span="8" class="m-td" v-else>
            <span class="count-style" content="否">否</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="是否同意须知" placement="top"> -->
            <span class="count-style">是否同意须知</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.auth" placement="top"> -->
            <span class="count-style">{{ PayerData.auth }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <!-- <el-tooltip content="阅读须知时间" placement="top"> -->
            <span class="count-style">阅读须知时间</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="PayerData.agree_at" placement="top"> -->
            <span class="count-style">{{ PayerData.agree_at }}</span>
            <!-- </el-tooltip> -->
          </el-col>
        </el-row>
        <el-divider content-position="left">查看手机号记录</el-divider>
        <el-row>
          <!-- <div> -->
          <el-timeline>
            <el-timeline-item v-for="log in showLogs" :timestamp="log.created_at" placement="top" :key="log.id">
              <el-card>
                <!-- <h4>更新 Github 模板</h4> -->
                <p>{{ log.admin.username }}， 在{{ log.created_at }}, 查看了该用户手机号。</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <!-- </div> -->
        </el-row>

      </el-tab-pane>

      <el-tab-pane name="2">
        <span slot="label">公司信息<el-badge style="top:-2px;" type="warning" class="item"
            :value="pageComPation.total"></el-badge></span>
        <el-table style="width: 100%;" border size="mini"
          :header-cell-style="{ background: '#ecf4ff', color: '#333', fontWeight: '900', fontSize: '0.28rem', }"
          :data="PayerCompanyData">
          <el-table-column label="公司名称" prop="company_name">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.company_name" placement="top">
                <div class="company_hover">
                  <span class="count_style" style="display: inherit">
                    <el-link type="primary" :underline="false" @click="CompanyInfoOpen(scope.row.id)">{{
                      scope.row.company_name }}</el-link>
                  </span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="所属业务">
            <template slot-scope="scope">
              <span>{{
                scope.row.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date_of_est" label="注册时间"></el-table-column>
          <el-table-column prop="regStatus" label="企业状态"></el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: .2rem;"
          @size-change="handleComSizeChange"
          @current-change="handleComCurrentChange"
          :current-page.sync="pageComPation.perPage"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="pageComPation.pageComSize"
          layout="sizes, total, prev, pager, next, jumper"
          :total="pageComPation.total"
          background
        >
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="关联订单" name="3">
        <slot></slot>
        <el-table :data="userWithOrder" size="small" border style="width: 100%; margin-top: 0.2rem" v-cloak>
          <el-table-column label="订单编号" width="150" fixed>
            <template slot-scope="scope">
              <el-link class="ellipsis-link" type="primary" @click="handleOrderInfo(scope.row.id)">{{
                scope.row.order_num
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="订单类型" width="100">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'"
                :content="scope.row.meal_singles.length > 0 ? getMeals(scope.row.meal_singles) : ''" placement="top">
                <span class="count-style" v-if="scope.row.order_reg">
                  {{ scope.row.order_reg.order_reg_name }} : {{ getMeals(scope.row.meal_singles) }}
                </span>
                <span v-else>无类型</span>
              </el-tooltip>
              <el-tooltip v-else :content="scope.row.order_reg.order_reg_name">
                <span class="count-style">
                  {{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : "" }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" prop="order_status" width="100"></el-table-column>
          <el-table-column label="沟通状态" prop="chat_status"></el-table-column>
          <el-table-column label="沟通专员(业务)" width="120">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.advisor ? scope.row.advisor.username : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务状态" prop="service_status"></el-table-column>
          <el-table-column label="服务人员">
            <template slot-scope="scope">
              <span class="count-style">{{ scope.row.operator_name ? scope.row.operator_name : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="total_amount"></el-table-column>
          <el-table-column label="订单来源" prop="platform" width="150"></el-table-column>
        </el-table>

        <el-pagination class="tr mt-10" @current-change="handleCurrentChange" :hide-on-single-page="false"
          :current-page.sync="pageOption.currentPage" :page-size="pageOption.pageSize" layout="total, prev, pager, next"
          :total="pageOption.total" :page-count="pageOption.pageCount" background>
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="反馈记录" name="4">
        <feed-back :orderId="userId" :type="4" :isShow="true" :cType="checkType"></feed-back>
      </el-tab-pane>

    </el-tabs>
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%"
      :append-to-body=true>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <!-- 公司信息 开始 -->
    <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" :append-to-body="true" direction="rtl"
      :before-close="handleCompanyInfoBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <!-- 公司信息 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer title="沟通记录" :visible.sync="chatRecordDrawer" :append-to-body="true" direction="rtl"
      :before-close="handleChatRecordBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->

    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
      :before-close="handleOrderInfoClose" :append-to-body="true">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="orderCheckType"></order-info>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CompanyInfo from 'common/CompanyInfo'
import ChatRecord from 'common/ChatRecord'
import MakePhone from 'common/MakePhone'
import FeedBack from 'common/FeedBack'
import OrderInfo from 'common/OrderInfo'

export default {
  name: 'UserwithOrder',
  components: {
    CompanyInfo,
    ChatRecord,
    MakePhone,
    FeedBack,
    OrderInfo
  },
  props: {
    companyId: Number,
    PayerData: Object,
    ThreadData: Object,
    // PayerCompanyData: Array,
    userOrderData: Array,
    bindUserId: Number,
    showLogs: Array
  },
  data() {
    return {
      phoneFrom_phone: [],
      phoneFromDraw: false,
      payerShowTab: '1',
      companyInfoDrawer: false,
      companyInfoId: null,
      userWithOrder: [],
      maskedNumber: '', // 部分隐藏的手机号
      showFullNumber: false, // 是否显示完整的手机号
      pageOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageCount: 0
      },
      pageComPation: {
        perPage: 1,
        pageComSize: 10,
        total: 0
      },
      perpageData: [],
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      userId: null,
      checkType: this.$feedBackConfig.customer_chat,
      orderCheckType: this.$feedBackConfig.order_service,
      orderInfoVisible: false,
      orderInfoId: null,
      PayerCompanyData: []
    }
  },
  watch: {
    userOrderData: {
      handler(message) {
        this.userWithOrder = []
        this.userWithOrder = message.slice(0, 10)
        this.pageOption.total = message.length
        this.pageOption.pageCount = Math.floor(this.pageOption.total / this.pageOption.pageSize)
      },
      deep: true
    },
    bindUserId: function (val) {
      this.userId = val || null;
      this.getUidComs(val)
    },
    showFullNumber() {
      this.$nextTick(() => {
        const eyeIcon = this.$el.querySelector('.eye-icon');
        if (this.showFullNumber) {
          eyeIcon.classList.replace('el-icon-view', 'el-icon-close');
        } else {
          eyeIcon.classList.replace('el-icon-close', 'el-icon-view');
        }
      });
    }
  },
  created() {
    this.userId = this.bindUserId || null;
  },
  updated() {
    this.updateMaskedNumber()
  },
  computed: {
    phoneNumber() {
      return this.PayerData.phone || ''
    },
    maskedName() {
      return function (name) {
        const phoneNumberRegex = /\d{11}/g; // 匹配手机号的正则表达式
        if (phoneNumberRegex.test(name)) {
          return name.replace(phoneNumberRegex, match => {
            const replacement = match.substring(0, 3) + '****' + match.substring(7);
            return replacement;
          });
        }
        return name;
      }
    },
    // maskedPhoneNumber() {
    //   return function(phoneNumber) {
    //     return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    //   };
    // },
  },
  methods: {
    getUidComs(val) {
      this.$axios
        .get("api/admin/customer/get_user_com?page=" + this.pageComPation.perPage, {
          params: {
            userId: val,
            pageSize: this.pageComPation.pageComSize
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.PayerCompanyData = data.data.data;
            this.pageComPation.total = data.data.total;
          }
        })
        .catch();
    },
    handleComSizeChange(val) {
      this.pageComPation.pageComSize = val;
      this.getUidComs(this.bindUserId);
    },
    handleComCurrentChange(val) {
      this.pageComPation.perPage = val;
      this.getUidComs(this.bindUserId);
    },
    toggleShowFullNumber() {
      this.showFullNumber = !this.showFullNumber
      if (this.showFullNumber === true) {
        // 查看记录
        this.$axios.post('/api/admin/customer/handle_show_record/', { param: this.phoneNumber }).then(res => {
          let { data } = res
          if (data.code === 0) {
            console.log(data.msg)
            // this.$message.success('调用成功，请注意接听来电')
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },
    updateMaskedNumber() {
      const len = this.phoneNumber.length
      if (len <= 4) return
      const start = (len - 4) / 2
      this.maskedNumber =
        this.phoneNumber.substr(0, start) +
        '*'.repeat(4) +
        this.phoneNumber.substr(start + 4)
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone)
      })
      this.phoneFromDraw = true
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }

      // this.$axios.post('/api/admin/call_logs/' + phone).then(res => {
      this.$axios.post('api/admin/call_logs_call', {
        phone
      }).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = []
      done()
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true
      setTimeout(() => {
        this.threadId = threadId
      })
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false
      this.threadId = null
      done()
    },
    handlePayerClick(tab, event) {
      console.log(event)
    },
    CompanyInfoOpen(cid) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyInfoId = cid
      })
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true
      setTimeout(() => {
        this.orderInfoId = orderId
      })
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null
      done()
    },
    getMeals(meals) {
      let str = ''
      for (let i = 0; i < meals.length; i++) {
        str += meals[i].item_name + '，'
      }
      return str
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null
      this.payerShowTab = '1'
      this.orderTotal = 0
      done()
    },
    handleCurrentChange(val) {
      this.userWithOrder = []
      let start = (val - 1) * this.pageOption.pageSize
      let end = val * this.pageOption.pageSize
      this.userWithOrder = this.userOrderData.slice(start, end)
    },
    copyPhone(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '已成功复制到剪切板',
        type: 'success',
      })
      oInput.remove()
    },
  },
  mounted() {
    this.userWithOrder = this.userOrderData.slice(0, 10)
    // console.log(this.userWithOrder)
    this.pageOption.total = this.userOrderData.length
    this.pageOption.pageCount = Math.ceil(this.pageOption.total / this.pageOption.pageSize)
  }
}
</script>

<style scoped>
  .el-drawer__wrapper >>> .el-drawer {
    overflow-y: auto !important;
  }
</style>

<style lang="stylus" scoped>
.UserWithOrder
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .m-tab
    border-top: 1px solid #dee2e6
    border-left: 1px solid #dee2e6
  .m-th
    height: 42px
    line-height: 42px
    padding: 0 5px
    border-bottom: 1px solid #dee2e6
  .m-td
    height: 42px
    line-height: 42px
    padding: 0 5px
    border-left: 1px solid #dee2e6
    border-right: 1px solid #dee2e6
    border-bottom: 1px solid #dee2e6
  .mt-10
    margin-top: .2rem
  .mt-20
    margin-top: .4rem
  .tr
    text-align: right
  .el-card__body p
    margin-top: .4rem
  .el-dialog .el-select
    width: 100%
  .eye-icon
    font-size: 14px
    margin-left: 5px
    transform: translateY(-1px)
    cursor: pointer
  .eye-icon.active
    color: #409eff
  .ellipsis-link
    display: inline-block
    max-width: 100%
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/common/UserWithOrder.vue